import { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import DropdownMenu from "components/organisms/DropdownMenu";
import Image from "components/organisms/Image";
import SHADOWS from "components/atoms/shadows";
import { Caption, H5 } from "components/atoms/text";
import InputText from "components/atoms/input/Text";
import Btn from "components/atoms/buttons";
import COLORS from "components/atoms/colors";
import ModalGuideMobile from "components/organisms/ModalGuideMobile";

import useEditProject from "apis/mutations/project/useEditProject";
import useDeleteProject from "apis/mutations/project/useDeleteProject";

import useCheckMobile from "hooks/useCheckMobile";
import Project from "types/Project";

import { ReactComponent as IconPlay } from "assets/images/project/play.svg";

interface Props {
  project: Project;
}

// 프로젝트 목록 아이템
const Item = ({ project }: Props) => {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState(project.name);
  const isMobile = useCheckMobile();

  // 프로젝트 삭제 api
  const deleteProject = useDeleteProject(project.id);

  // 프로젝트 수정 api
  const editProject = useEditProject(project.id);

  // 저장하기 버튼
  const handleSave = () => {
    if (!name) return;
    editProject({ name });
    setShowForm(false);
  };

  const pingTotal = project.scenes.map(({ pins }) => pins).flat().length;

  return (
    <Container className="relative">
      {/* 모바일 디바이스의 경우 이용제한 모달 띄우기 => 기획변경으로 사용하지 않음 */}
      {/* <ModalGuideMobile
        activator={(onOpen) => (
          <ImageContainer
            onClick={() =>
              isMobile ? onOpen() : navigate(`/project/${project.id}`)
            }
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
          >
            {hover && (
              <Layer>
                <IconPlay />
              </Layer>
            )}
            <Image src={project.scenes[0]?.image} className="!h-auto" />
          </ImageContainer>
        )}
            />*/}

      <ImageContainer
        onClick={() => navigate(`/project/${project.id}`)}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        {hover && (
          <Layer>
            <IconPlay />
          </Layer>
        )}
        <Image src={project.scenes[0]?.image} className="!h-auto" />
      </ImageContainer>

      <div className="flex flex-col justify-center flex-1 px-3 py-2">
        {showForm ? (
          <div className="flex items-center gap-2">
            <InputText
              small
              placeholder="Title"
              value={name}
              onChange={(e) => setName(e.target.value)}
              shape="square"
            />
            <Btn.Blue
              onClick={handleSave}
              size="xsSmall"
              className="flex-none !px-2"
              inActive={!name}
            >
              저장
            </Btn.Blue>
          </div>
        ) : (
          <div className="flex justify-between items-center">
            <div className="flex-1 min-w-0">
              <Title>{project.name}</Title>
              <Caption className="text-black-60%">
                {project.scenes.length} Scene / {pingTotal} Item
              </Caption>
            </div>
            <DropdownMenu
              onOpenForm={() => setShowForm(true)}
              onDelete={deleteProject}
            />
          </div>
        )}
      </div>
    </Container>
  );
};

const Container = styled.li`
  display: inline-flex;
  flex-direction: column;
  height: 168px;
  border-radius: 10px;
  box-shadow: ${SHADOWS.card};
`;

const ImageContainer = styled.div`
  position: relative;
  flex: none;
  height: 112px;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Layer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.black.blur};
`;

const Title = styled(H5)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export default Item;
